import { render, staticRenderFns } from "./support-detail.component.html?vue&type=template&id=36eb2980&scoped=true&external"
import script from "./support-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./support-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./support-detail.component.scss?vue&type=style&index=0&id=36eb2980&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb2980",
  null
  
)

export default component.exports